module.exports = __webpack_public_path__ + "static/img/4.399c31a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/4.png
// module id = sNmO
// module chunks = 0